<template>
	<div>
		<notifications position="top center" group="info" />

		<h1 v-show="!minimal">Vues DB</h1>

		<div v-show="!dashboard">
			<b-select @change="set_name(name)" v-model="name" :options="names"></b-select>
			<br />
		</div>

		<div v-show="!dashboard || show_params">
			<params ref="tp" :dashboard="dashboard"></params>
			<br />
		</div>

		<div v-if="!dashboard || show_params">
				<b-button @click="test(false)">Exécuter</b-button>
				<test_as_user v-if="!dashboard" @change="onTestUserChange"></test_as_user>

				<br /><br />

				<b-alert variant="danger" v-if="error" show>Erreur : {{error}}</b-alert>
		</div>

		<div v-show="!dashboard">
			<p v-if="data_test.length > 0">Nombre de résultat{{ data_test.length > 1 ? "s": ""}} : {{ data_test.length}}</p>
	
			<edit_tabulator :default_visible="default_visible" @data="update_data_selection" @update="update_data" v-show="data_test.length > 0" :extern_file="false" ref="tabulator"></edit_tabulator>
		</div>
		
	</div>
</template>

<script>
	var clone = require("clone");

	import * as json2csv from "json2csv";
	import uniqueId from "lodash.uniqueid";
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	import $ from "jquery";
	import { JSONEditor } from "@json-editor/json-editor";

	import store from "../store";
	import users from "../services/users.js";
	import client from "../services/client.js";
	import library from "../services/library.js";
	import database from "../services/database.js";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import params from "../components/params.vue"
	import test_as_user from "../components/TestAsUser.vue";

	export default {
		name: "database_request_view",
		components: {
			edit_tabulator: edit_tabulator,
			params: params,
			test_as_user
		},
		props: {
			minimal: {
				default: false
			},
			dashboard : {
				default: false
			},
			form : {
				default: false
			},
			show_params : {
				default: false
			},
			default_visible: {
				default: true,
				type: Boolean
			},
			// jwt d'un utilisateur simulé ("tester en tant que"), fourni par un parent
			// (ex: Dashboard.vue lors d'une prévisualisation). Ignoré si un sélecteur local
			// est aussi utilisé (cas standalone / validation), le local est alors prioritaire.
			test_jwt: {
				default: null
			}
		},
		watch: {
			data_test: {
				deep: true,
				handler() {
					this.$emit("update", this.data_test);
				},
			}
		},
		data() {
			return {
				id: uniqueId(),

				tables: [],
				tables_name: [],

				table: "",

				type: "db",
				names: [],
				name: "",

				data_test: [],
				error: "",
				sql: "",

				request: {},

				local_test_user: null
			};
		},
		computed: {
			_effective_test_jwt() {
				return (this.local_test_user && this.local_test_user.jwt) || this.test_jwt || null;
			}
		},
		methods: {
			onTestUserChange(test_user) {
				this.local_test_user = test_user;
			},
			update_data(id, data) {
				this.data_test = data;
			},
			update_data_selection(data) {
				this.data_test = data;
			},
			get_data: function () {
				return this.data_test;
			},
			get_data_blob: async function () {
				var str_csv = json2csv.parse(this.data_test, {
					fields: Object.keys(this.data_test[0]),
					fieldNames: Object.keys(this.data_test[0]),
				});

				return new Blob([str_csv], {
					type: "text/plain",
				});
			},
			get_data_files: async function (all_files = true) {
				if (!all_files) return [];

				var str_csv = json2csv.parse(this.data_test, {
					fields: Object.keys(this.data_test[0]),
					fieldNames: Object.keys(this.data_test[0]),
				});

				return [
					new File([str_csv], "data.csv", {
						type: "text/csv",
					}),
				];
			},
			async save()
			{
				var request = clone(this.request);

				if (request.sql)
					delete request.sql;

				if (request.tables)
				{
					for (var i = 0; i < request.tables.length; i++)
					{
						for (var j = 0; j < request.tables[i].columns.length; j++)
						{
							delete request.tables[i].columns[j].exemple
						}
					}
				}
				else
					return null

				return {
					request,
					name: this.name,
					params: this.$refs.tp.get_obj()
				}
			},
			async set_name(name)
			{
				console.log(name)

				var result = await library.getby_production(this.type, name);

				console.log(result)

				this.load(result.element[0].data, name);
			},
			async load(data, name)
			{
				if (typeof data == "string")
					data = JSON.parse(data);

				console.log(this.name)
				console.log(data)
				if (name)
					this.name = name;
				if (!this.name && data)
					this.name = data.name;
				console.log(this.name)

				this.request = data.request;

				var self = this;

				if (this.request.editor_params)
				{
					this.$refs.tp.set(this.request.editor_params);
				}

				if (data.params)
				{
					this.$refs.tp.set_obj(data.params);
				}

				//this.test();
			},
			async save_params() {
				return this.$refs.tp.get_obj();
			},
			async load_params(data) {
				this.$refs.tp.set_obj(data);
			},
			async test(count = false)
			{
				var user_params = this.$refs.tp.get_obj();

				if (count)
					this.request.count = true;
				else
					this.request.count = false;

				var response = await database.request(this.request, user_params, this._effective_test_jwt);

				this.data_test = [];
				this.error = "";

				this.request.sql = response.sql;

				if (response.data)
				{
					this.data_test = response.data;
					this.$refs.tabulator.set_data(this.data_test);
					this.$emit("update", this.data_test);
				}
				if (response.error)
					this.error = response.error;
			}
		},
		mounted: async function () {
			
			var self = this;
			
			if (!this.dashboard && !this.form)
			{
				if (
					store.state.user.rules &&
					!store.state.user.rules.db_requests
				) {
					this.$router.push({ name: "profile" });
				}
			}

			var resp = await library.getby_production(this.type);

			console.log(this.names)

			this.names = []
			for (var i = 0; i < resp.element.length; i++)
			{
				this.names.push(resp.element[i].name)
			}
		},
	};
</script>
